
<template>
    <header class="public-header">
      <div class="container">
        <div class="logo">
          <img src="@/assets/logo_2025.png" alt="StreamboxTV" />
        </div>
  
        <nav :class="{ open: isMenuOpen }" class="nav">
      
            <router-link to="/admin/upload" class="nav-link">Playlist manager</router-link>

<router-link to="/admin/instructions" class="nav-link">Playlist instructions</router-link>
<router-link to="/admin/manage" class="nav-link">Content editor</router-link>
<router-link to="/admin/devices" class="nav-link">Activity </router-link>
<a @click.prevent="logout" class="nav-link">Logout</a>
        </nav>
  
        <button class="menu-toggle" @click="isMenuOpen = !isMenuOpen">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  </template>
  
  <script>
  export default {
    name: "PublicHeader",
    data() {
      return {
        isMenuOpen: false,
      };
    },
    watch: {
      $route() {
        this.isMenuOpen = false; // zatvori meni posle navigacije
      }
    },
    methods:{
      logout() {
        localStorage.removeItem("adminToken");
        this.$router.push("/admin/login");
      },
    }
  };
  </script>
  
  <style scoped>
  .public-header {
    background: black;
    color: white;
    padding: 10px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    position: sticky;
    top: 0;
    z-index: 1000;
  }
  
  .container {
    max-width: 1200px;
    margin: auto;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .logo img {
 
    height: 30px;
  }
  
  .nav {
    display: flex;
    gap: 20px;
  }
  
  .nav-link {
    color: white;
    text-decoration: none;
    font-weight: bold;
    transition: color 0.3s;
  }
  
  .nav-link:hover {
    color: #2a84ff;
  }
  
  .menu-toggle {
    display: none;
    flex-direction: column;
    gap: 5px;
    background: rgb(18, 19, 19);
    border: none;
    cursor: pointer;
  }
  
  .menu-toggle span {
    width: 25px;
    height: 3px;
    background: white;
    display: block;
  }
  
  @media (max-width: 768px) {
    .nav {
      position: absolute;
      top: 60px;
      right: 0;
      background: rgb(5, 5, 5);
      flex-direction: column;
      width: 100%;
      text-align: right;
      padding: 10px 20px;
      display: none;
    }
  
    .nav.open {
      display: flex;
    }
  
    .menu-toggle {
      display: flex;
    }
  }
  </style>
  